import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { COMPANIA_MAIN } from 'constants/codigosTransacciones'

import FichaPage from './ficha'

export default function CompaniasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COMPANIA_MAIN}`} component={FichaPage} />
      </Switch>
    </Suspense>
  )
}
